module.exports = __webpack_public_path__ + "img/7.2b24673f.jpg";